import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    rd_id: Yup.string()
      .trim()
      .required("This field is required")
  }),
  mapPropsToValues: props => ({
    rd_id: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
